module.exports = __webpack_public_path__ + "img/google.b80b563e.svg";